import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { Input, type InputProps } from '../ui/input'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'

type NumberFieldProps = {
    label: string
    name: string
    percentage?: boolean
} & Partial<InputProps>

export default function NumberField({ label, name, percentage, ...props }: NumberFieldProps) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel>{label}</FormLabel>
                    <FormControl>
                        <div className='relative'>
                            <Input
                                id={name}
                                inputMode='numeric'
                                pattern='[0-9]*'
                                type='text'
                                {...props}
                                value={field.value ?? ''}
                                onChange={(e) => {
                                    const raw = e.target.value
                                    if (raw === '') {
                                        field.onChange(undefined)
                                        return
                                    }
                                    const intVal = parseInt(raw.replace(/[^0-9]/g, ''), 10)
                                    if (Number.isNaN(intVal)) {
                                        field.onChange(undefined)
                                    } else {
                                        field.onChange(intVal)
                                    }
                                }}
                                className={percentage ? 'pr-10' : undefined}
                            />
                            {percentage && (
                                <span className='pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm text-muted-foreground'>%</span>
                            )}
                        </div>
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}


